<template>
  <div class='course__bannerContainer' :style="{background: courseMsg.indexMainHue}">
    <div class="course__mask"></div>
    <div class="course__banner">
      <div class="course__bannerImage">
        <img :src="courseMsg.productCoverUrl">
      </div>
      <div class="course__bannerContent">
        <div class="course__title">{{courseMsg.courseTitle}}</div>
        <div class="course__desc">{{courseMsg.courseSubhead}}</div>
        <div class="course__sologon">{{courseMsg.desHead}}</div>
        <div class="course__tipsList">
          <div class="course__tips" v-for="(item, index) in courseMsg.tags" :key='index'>{{item.tagName}}</div>
        </div>
        <div v-if="courseMsg.studyNumCopy" class="course__studyNum">{{courseMsg.studyNumCopy}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    courseMsg: {
      type: Object,
    }
  },
  mounted() {
    // console.log(this.courseMsg);
  }
};
</script>
<style lang="scss" scoped>
  .course {
    &__sologon {
      font-size: .14rem;
      margin-bottom: .1rem;
      opacity: .6;
      width: 2.17rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #fff;
    }

    &__mask {
      background: rgba(0 ,0, 0, .1);
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      z-index: 3;
    }

    &__bannerContainer {
      background: #6d6d80;
      position: relative;
      z-index: 3;
    }

    &__bannerContent {
      // padding-top: .1rem;
      box-sizing: border-box;
      width: 2.17rem;
    }

    &__studyNum {
      color: #fff;
      font-size: .12rem;
    }

    &__tips {
      border-radius: .1rem;
      font-size: .12rem;
      padding: .02rem .08rem;
      box-sizing: border-box;
      color: #fff;
      margin-right: .1rem;
      background: rgba(0, 0, 0, .1);
    }

    &__tipsList {
      display: flex;
      // margin-bottom: .16rem;
    }

    &__title {
      color: #fff;
      font-size: .18rem;
      margin-bottom: .06rem;
      font-weight: bold;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      -webkit-box-orient: vertical;
      width: 2.17rem;
    }

    &__desc {
      font-size: .14rem;
      color: #fff;
      margin-bottom: .04rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 2.17rem;
    }

    &__banner {
      padding-top: .2rem;
      display: flex;
      width: 100%;
      padding-left: .2rem;
      padding-bottom: .2rem;
      box-sizing: border-box;
    }

    &__bannerImage {
      width: .98rem;
      height: 1.29rem;
      margin-right: .2rem;
      border-radius: .08rem;
      overflow: hidden;

      img {
        width: 100%;
        border-radius: .08rem;
        overflow: hidden;
      }
    }
  }
</style>
